import { PatientCommandParams } from './PatientCommandParams';
import { Command } from './Command';

export type StornoPatientSummaryContactInformationParams =
	PatientCommandParams & {
		recordIds: string[];
	};

export const StornoPatientSummaryContactInformation = (
	params: StornoPatientSummaryContactInformationParams,
): Command => {
	return {
		operation: 'ZrusKontaktneUdajePacientskehoSumaru_v4',
		params,
	};
};
